import { Activity, CurriculumType } from "@/util/enum";

export interface IContentModel {
	name: string;
}

export enum ComponentTaughtType {
	None,
	Normal,
	Optional
}

export enum LessonPlanItemType {
	EstimatedTime,
	Component,
	Activity = 5
}

export enum PlaylistItemType {
	Question,
	Conversation,
	Transition
}

export interface IComponentModel {
	id?: string;
	name?: string;
	title?: string;
	contentTypeId?: number;
	mediaSlotId?: number;
	contentGroupId?: number;
	relatedExposureDurations: number[];
}

export interface ILessonPlanItemModel {
	itemType: LessonPlanItemType;
	componentId?: string;
	componentName?: string;
	lessonNumber: number;
	taughtType: ComponentTaughtType;
	lessonSequence?: number;
	mediaSlotId?: number;
	activityId?: number;
}

export enum LessonPlanItemPropsName {
	item = "componentName",
	position = "lessonSequence"
}
export interface ILessonPlanRowModel {
	rowType: LessonPlanItemType;
	rowKey: string;
	component?: IComponentModel;
	exposure?: string;
	lessonPlanItems: ILessonPlanItemModel[];
	estimatedTime: number[];
	activityId?: number;
}

export enum LessonPlanColumns {
	Component = "component",
	Exposure = "exposure",
	LessonColumn = "lessonPlanItems",
	ExtraColumn = "extraColumn"
}

export interface IMasterPlan4DBModel {
	id?: string;
	name?: string;
	description?: string;
	status?: number;
	methodology?: number;
	versionGroupId: string;
	createdTime?: string;
	updatedTime?: string;
	lessonPlan: ILessonPlan4DBModel[];
}

export interface ILessonPlan4DBModel {
	id?: string;
	action?: MasterLessonPlanAction;
	lessonPlanVersionId?: string;
	unitId?: number;
	sequence?: number;
	lessonPlanItem: ILessonPlanItem4DBModel[];
	conversationSpeed?: number;
}

export interface ILessonPlanItem4DBModel {
	id?: string;
	lessonPlanId?: string;
	componentId?: string;
	sequence?: number;
	type?: LessonPlanItemType4DB;
	mediaSlotId?: number;
	createdTime?: string;
	updatedTime?: string;
	activityId?: number;
}

export enum MasterLessonPlanAction {
	Updating,
	Adding,
	Deleting
}

export enum LessonPlanItemType4DB {
	ExposureContent,
	OptionalContent,
	Activity = 5
}

export interface ICustomActivityModel {
	startUnitId: number;
	endUnit: number;
	id: number;
	curriculumType: CurriculumType;
	maxDuration: number;
	minDuration: number;
	name: string;
	references: number;
	methodologies: number[];
}
